// extracted by mini-css-extract-plugin
module.exports = {"root":"DownloadApp_root__2453z","lightBlue":"DownloadApp_lightBlue__2CVAS","buttons":"DownloadApp_buttons__2e3Z2","button":"DownloadApp_button__1V3Xl"};